import { render, staticRenderFns } from "./sidebarEditCustomObject.vue?vue&type=template&id=7b7ea252&scoped=true"
import script from "./sidebarEditCustomObject.vue?vue&type=script&lang=js"
export * from "./sidebarEditCustomObject.vue?vue&type=script&lang=js"
import style0 from "./sidebarEditCustomObject.vue?vue&type=style&index=0&id=7b7ea252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7ea252",
  null
  
)

export default component.exports